import { wordEnding } from '@/shared/utils/wordEnding';
import { FC, useCallback, useMemo } from 'react';
import { IDeliveryPoint } from '@/shared/api/postDeliveryBoxberryPoints/types';
import {
  cvaAddress,
  cvaAddressIcon,
  cvaCount,
  cvaCountIcon,
  cvaDate,
  cvaLeft,
  cvaLogo,
  cvaRight,
  cvaRoot,
  cvaType,
  cvaWorkingHours,
  cvaWorkingHoursIcon,
} from './PvzMapItemStyles';
import IconCaretRight from '/public/icons/arrow-right.svg';
import IconCalendar from '/public/icons/calendar.svg';
import IconCdekCircle from '/public/icons/cdek_circle.svg';
import IconCheck from '/public/icons/check-white.svg';
import IconMarketCircle from '/public/icons/market_circle.svg';
import IconPochtaCircle from '/public/icons/pochta_circle.svg';
import IconWait from '/public/icons/wait.svg';

interface Props {
  data: IDeliveryPoint;
  address: string;
  type: string;
  icon: string;
  date: string;
  workingHours: string;
  itemsCount: number;
  allItems: number;
  onClickPvz: (val: any) => void;
}

const PvzMapItem: FC<Props> = ({ address, type, icon, date, workingHours, itemsCount, allItems, onClickPvz, data }) => {
  const onClick = useCallback(() => {
    onClickPvz(data);
  }, [onClickPvz, data]);

  const renderIcon = useMemo(
    () => (icon === 'cdek' ? <IconCdekCircle /> : icon === 'boxberry' ? <IconMarketCircle /> : <IconPochtaCircle />),
    [icon]
  );

  const renderType = useMemo(() => {
    if (type === 'pvz') {
      return 'Пункт выдачи';
    }
    if (type === 'postamat') {
      return 'Постамат';
    }

    return type;
  }, [type]);

  const isAll = useMemo(() => itemsCount === allItems, [itemsCount, allItems]);

  const renderNote = useMemo(() => {
    if (itemsCount === allItems) {
      return 'Все товары';
    }

    return `${itemsCount} ${wordEnding(itemsCount, ['товар', 'товара', 'товаров'])} из ${allItems}`;
  }, [itemsCount, allItems]);

  return (
    <div className={cvaRoot()} onClick={onClick}>
      <div className={cvaLeft()}>
        <div className={cvaLogo()}>{renderIcon}</div>
      </div>
      <div className={cvaRight()}>
        <div className={cvaType()}>{renderType}</div>
        <address className={cvaAddress()}>
          {address}
          <IconCaretRight className={cvaAddressIcon()} />
        </address>
        <div className={cvaDate()}>
          Можно забрать&nbsp;<span>{date}</span>
        </div>
        {/* todo: сделать кнопку развернуть */}
        <div className={cvaWorkingHours()}>
          <IconCalendar className={cvaWorkingHoursIcon()} /> {workingHours}
        </div>
        <div
          className={cvaCount({
            allItems: isAll,
          })}
        >
          {isAll ? <IconCheck className={cvaCountIcon()} /> : <IconWait className={cvaCountIcon()} />}
          {renderNote}
        </div>
      </div>
    </div>
  );
};

export default PvzMapItem;
